import { ProductModelType } from '@teinor/erp/types/company/product'
import { connect, ConnectedProps } from 'react-redux'
import ModalCreateEdit from '../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../../baseComponents/ModalsLayouts/types'
import ProductCategories from '../../../../../../../baseComponents/Product/ProductCategories'
import { OnChangeMainCategoryTy } from '../../../../../../../baseComponents/Product/ProductCategories/types'
import { FormRender } from '../../../../../../../forms/FormRenderer/types'
import withLoading from '../../../../../../../utils/hoc/withLoading'
import useModalCreateProductLogic from '../../../../../../../utils/hooks/product/useModalCreateProductLogic'
import useLangData from '../../../../../../../utils/hooks/useLangData'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { AllReduxPayloads } from '../../../../../../../utils/reducers'
import { getActiveLangs } from '../../../../../../../utils/reducers/getters'
import { GroupVatPayload } from '../../../../../../../utils/reducers/globals/groupVats'
import NewProductSpecificPricesTable from '../../../../../../../specificComponents/Product/NewProductSpecificPricesTable'
import useModalCreateProductSpecificPricesLogic from '../../../../../../../utils/hooks/product/useModalCreateProductSpecificPricesLogic'
import TwinTrans from '../../../../../../../baseComponents/TwinTrans'


interface ModalCreateMaterialProps extends ModalEditComponentProps { 
    customLocation?: string
}
interface ModifiedCreateMaterialModelType extends ProductModelType {
    name: string
    nameLangs: string
    LangId: string
    categories: string[]
    image: string
}
const ModalCreateMaterial: React.FC<ModalCreateMaterialProps & ReduxModalCreateMaterial> = ({ userPermissions, allRowData, onSubmit, groupVats, customLocation, ...rest }) => {
    const { handleOnSubmit, handleOnError, onChangeMain, reference, setReference } = useModalCreateProductLogic({ customLocation, onSubmit })
    const { t } = useTwinTranslation()
    const { changeLang, selectedLang, data, changeValCurrentLang } = useLangData({ myData: null, fieldsToLang: ['name'], keyValue: 'LangId' })
    const { dataPrices, setDataPrices, beforeSubmitAddSpecificPrices } = useModalCreateProductSpecificPricesLogic({})
    const fields: FormRender<ModifiedCreateMaterialModelType> = [
        {
            cols: 2,
            elements: [
                {
                    name: 'LangId',
                    label: t('language', 'Idioma'),
                    component: 'CustomSelectWithSearchBar',
                    items: getActiveLangs(),
                    value: selectedLang,
                    onChange: changeLang,
                    required: true,
                },
                {
                    name: 'name',
                    label: t('name', 'Nombre'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true,
                    lang: selectedLang,
                    value: data?.['name'][selectedLang] ?? '',
                    onChange: (name) => changeValCurrentLang('name', name),
                },
                {
                    name: 'nameLangs',
                    component: 'InputHidden',
                    value: JSON.stringify(data?.name)
                },
                {
                    name: 'productType',
                    component: 'InputHidden',
                    value: 1
                },
                {
                    name: 'reference',
                    label: t('reference', 'referencia'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true,
                    value: reference,
                    onChange: (value) => setReference(value)
                },
                {
                    name: 'GroupVatId',
                    label: t('groupVat', 'Grupo de impuestos'),
                    component: 'CustomSelectWithSearchBar',
                    items: groupVats || {},
                    required: true
                },
                {
                    name: 'categories',
                    component: 'Custom',
                    render: ModalProductCategories,
                    extraProps: { onChangeMain }
                },
                {
                    name: 'image',
                    label: t('imageProduct', 'Imagen del producto'),
                    component: 'ImageInput',
                },
            ]
        }
    ]

    return (<ModalCreateEdit fields={fields} url={'/api/app/product/createProduct'} beforeSubmit={beforeSubmitAddSpecificPrices} translations={{
        title: t('createMaterial', 'Crear Material'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} onSubmit={handleOnSubmit} onChangeError={handleOnError} {...rest} imagePath={['tmp']} className='notFlexAutoFormRender'>
        <div className='regular18 mb-20'>
            <TwinTrans transKey='prices'>Precios</TwinTrans>
        </div>
        <NewProductSpecificPricesTable dataPrices={dataPrices} setDataPrices={setDataPrices} />
    </ModalCreateEdit>)
}

interface ModalProductCategoriesProps {
    extraProps: {
        onChangeMain: OnChangeMainCategoryTy
    }
}

const ModalProductCategories: React.FC<ModalProductCategoriesProps> = ({ extraProps }) => {
    return (<ProductCategories productType={1} selectedCategories={[1]} className='createproduct_categories' onChangeMain={extraProps.onChangeMain} />)
}

const modalCreateMaterialDispatch = {
    setGroupVats: (payload: GroupVatPayload) => ({ type: 'CHANGE_GROUPVAT', payload }),
}

export type ReduxModalCreateMaterial = ConnectedProps<typeof modalCreateMaterialConnect>
const mapModalCreateMaterialConnector = (state: AllReduxPayloads) => ({ groupVats: state.groupVats })
const modalCreateMaterialConnect = connect(mapModalCreateMaterialConnector, modalCreateMaterialDispatch)

const modalCreateMaterialConnectLoading = withLoading(ModalCreateMaterial, [{ fetchUrl: '/api/app/config/vat/getAllGroupsVat', propName: 'groupVats', setFunctionName: 'setGroupVats' }])

const ModalCreateMaterialConnect = modalCreateMaterialConnect(modalCreateMaterialConnectLoading)


export default ModalCreateMaterialConnect